<template>
	<div class="standard">
		<div class="standard-header" />
		<div class="standard-content">
			<div :class="[
          'content__item',
          (!hasRight || standard.stock === 0) && 'standard-content__item--empty'
        ]" v-for="standard in standardList" :key="standard.id" @click="onItemClick(standard)">
				<div class="content__item-img">
					<img :src="`${imgPrefix}${standard.thumbnailUrl}`" />
				</div>
				<div class="content__item-text">{{ standard.name }}</div>
			</div>
		</div>
		<div class="standard-btn-rule" @click="onOpenRuleDialog">活动规则</div>
		<div class="standard-btn-record" @click="onRouteExchangeRecord">
			兑换记录
		</div>
		<van-dialog v-model:show="isRuleDialogShow" title="活动规则">
			<div class="rule-popup">
				<div>1.活动时间：2022年3月1日-2022年6月30日</div>
				<div>2.领取时间：达标次月15日以后，领取时限为1个月，逾期作废。</div>
				<div>
					3.活动内容：首次达到基础客户以上等级（金融资产月日均1万元以上），并开通手机银行、理财签约,可获得面值50元宣传品，若客户同时购买1万元以上任意金融产品，则最高可获得面值100元宣传品。活动宣传品：京东E卡、百果园、天猫宣、盒马、沃尔玛五选一。
				</div>
				<div>
					4.本活动仅限华夏银行深圳分行借记卡客户参与,每人限参与一次，名额有限，抢完即止。
				</div>
				<div>5.领取的宣传品请在有效期内使用，过期作废、无法退款。</div>
				<div>
					6.本活动所涉产品和服务由活动商户提供，如因商户提供的商品及服务产生争议，华夏银行不承担任何责任，相关问题由商户负责解决，服务专线：4000-852-818（服务时间9:00-18:00）。
				</div>
			</div>
		</van-dialog>
	</div>
</template>

<script>
	import {
		reactive,
		toRef,
		onMounted
	} from 'vue'
	import {
		Dialog
	} from 'vant'
	import {
		useRoute,
		useRouter
	} from 'vue-router'
	import globalVariables from '@/utils/globalVariables'
	import api from '@/api'

	export default {
		setup() {
			const router = useRouter()
			const route = useRoute()
			const {
				activityCode
			} = route.query
			const data = reactive({
				isRuleDialogShow: false,
				standardList: [],
				hasRight: true,
				isMassage:""
			})

			const onItemClick = standard => {
				if (!data.hasRight) {
					Dialog.alert({
						message: data.isMassage
					})
					return
				}
				if (standard.stock === 0) {
					Dialog.alert({
						message: '该商品已售罄'
					})
					return
				}
				router.push({
					path: '/productDetail',
					query: {
						id: standard.id,
						activityCode
					}
				})
			}

			const onOpenRuleDialog = () => {
				data.isRuleDialogShow = true
			}

			const onRouteExchangeRecord = () => {
				router.push('/exchangeRecord')
			}

			onMounted(() => {
				document.title = ''
				api
					.getProductList({
						activityCode
					})
					.then(res => {
						data.standardList = res.data
					})

				api
					.isHaveRight({
						activityCode
					})
					.then(res => {
						const {
							status,
							message
						} = res.data
						if (status === -1) {
							data.hasRight = false
							data.isMassage = message
							Dialog({
								title: '友情提醒',
								message
							})
						}
					})

				// 测试代码
				// data.standardList = [
				//   {
				//     id: 7,
				//     name: '测试商品7_虚拟卡密类型',
				//     price: 20.0,
				//     stock: 10,
				//     thumbnailUrl: '20220412120729618.png',
				//     headerImgUrl: '20220412120729618.png',
				//     detailImgUrl: '20220412120729618.png',
				//     productType: 4,
				//     description: ''
				//   }
				// ]
			})

			return {
				imgPrefix: globalVariables.imgPrefix,
				isRuleDialogShow: toRef(data, 'isRuleDialogShow'),
				isMassage: toRef(data, 'isMassage'),
				standardList: toRef(data, 'standardList'),
				hasRight: toRef(data, 'hasRight'),
				onOpenRuleDialog,
				onRouteExchangeRecord,
				onItemClick
			}
		}
	}
</script>

<style lang="less" scoped>
	.standard {
		min-height: 100vh;
		background-image: url('../../assets/standard-back.png'),
			url('../../assets/standard-back-star.png');
		background-repeat: no-repeat;
		background-size: 100%;
		background-position: left top, center 130px;
		background-color: #8e1c14;
		overflow: hidden;

		.standard-header {
			width: 306px;
			height: 129px;
			background-image: url('../../assets/standard-title.png');
			background-repeat: no-repeat;
			background-size: 100%;
			margin: 87px 0 0 39px;
		}

		.standard-content {
			display: flex;
			flex-wrap: wrap;
			margin-left: 23px;
			margin-top: -10px;
			padding-bottom: 30px;

			.content__item {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-left: 37px;
				margin-top: 25px;

				.content__item-img {
					img {
						width: 113px;
						height: 76px;
					}
				}

				.content__item-text {
					font-size: 10px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #ffffff;
					margin-top: 5px;
				}
			}

			.content__item:active {
				opacity: 0.8;
			}

			.standard-content__item--empty {
				.content__item-img {
					filter: grayscale(100%);
				}
			}
		}

		.standard-btn-rule {
			position: absolute;
			top: 175px;
			left: 0;
			background-color: #f3c15f;
			width: 48px;
			height: 50px;
			font-size: 15px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #ca2e2b;

			display: flex;
			align-items: center;
			justify-content: center;
			padding: 8px;
			box-sizing: border-box;

			border-top-right-radius: 5px;
			border-bottom-right-radius: 5px;
		}

		.standard-btn-rule:active {
			opacity: 0.8;
		}

		.standard-btn-record {
			position: absolute;
			top: 175px;
			right: 0;
			background-color: #f3c15f;
			width: 48px;
			height: 50px;
			font-size: 15px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #ca2e2b;

			display: flex;
			align-items: center;
			justify-content: center;
			padding: 8px;
			box-sizing: border-box;

			border-top-left-radius: 5px;
			border-bottom-left-radius: 5px;
		}

		.standard-btn-record:active {
			opacity: 0.8;
		}

		.rule-popup {
			margin: 0 20px;
			font-size: 12px;
		}
	}
</style>
